// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ControlFilledSvg from "@ant-design/icons-svg/es/asn/ControlFilled";
import AntdIcon from '../components/AntdIcon';

var ControlFilled = function ControlFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ControlFilledSvg
  }));
};

ControlFilled.displayName = 'ControlFilled';
export default React.forwardRef(ControlFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ControlFilled.js
// module id = 863
// module chunks = 0